import { useLoading, useServerError } from 'shared/hooks'
import { useGetArtistQuery } from 'modules/Artists/graphql/queries'

export const useArtist = (id: string = '') => {
  const {
    data: artistResponse,
    error: artistError,
    loading: artistLoading
  } = useGetArtistQuery({
    fetchPolicy: 'no-cache',
    variables: { id },
    skip: !id
  })

  useLoading({ isLoading: artistLoading })
  useServerError([artistError])

  return {
    artist: artistResponse?.getArtist || null,
    products: artistResponse?.getArtist?.products || []
  }
}
